import { TrendingUp, TrendingDown } from 'lucide-react';

export function StatCard({ title, value, icon: Icon, trend, trendValue, color = 'default', prefix = '' }) {
  const isPositive = trend === 'up';
  
  return (
    <div 
      className="group relative overflow-hidden rounded-sm border border-white/10 bg-[linear-gradient(135deg,rgba(255,255,255,0.03),rgba(9,9,11,0.82))] p-6 shadow-[inset_0_1px_0_rgba(255,255,255,0.04)] transition-all duration-200 hover:border-[#D4AF37]/30 hover:shadow-[0_10px_24px_rgba(0,0,0,0.28)]"
      data-testid={`stat-card-${title.toLowerCase().replace(/\s+/g, '-')}`}
    >
      <div className="pointer-events-none absolute inset-0 opacity-0 transition-opacity duration-200 group-hover:opacity-100 bg-[radial-gradient(circle_at_top_right,rgba(212,175,55,0.14),transparent_45%)]" />
      <div className="flex items-start justify-between mb-4">
        <span className="text-[11px] font-bold uppercase tracking-[0.18em] text-zinc-500">{title}</span>
        {Icon && (
          <div className={`h-10 w-10 rounded-sm border flex items-center justify-center ${
            color === 'primary'
              ? 'border-[#D4AF37]/35 bg-[#D4AF37]/12 text-[#D4AF37]'
              : 'border-white/10 bg-white/[0.03] text-zinc-400'
          }`}>
            <Icon className="w-5 h-5" strokeWidth={1.5} />
          </div>
        )}
      </div>
      
      <div className="space-y-2">
        <p className="text-3xl font-black tracking-tight text-white">{value}</p>
        
        {trendValue && (
          <div className="flex items-center gap-1.5">
            {isPositive ? (
              <TrendingUp className="w-4 h-4 text-[#D4AF37]" strokeWidth={1.5} />
            ) : (
              <TrendingDown className="w-4 h-4 text-red-400" strokeWidth={1.5} />
            )}
            <span className={`text-xs font-medium ${isPositive ? 'text-[#D4AF37]' : 'text-red-400'}`}>
              {trendValue}
            </span>
          </div>
        )}
      </div>
    </div>
  );
}
